<template>
  <div class="p-0 col-12 animated fadeIn">
    <div class="card">
      <div class="card-body">
        <div class="form form-horizontal" style="margin: 15px;">
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Sales Type</label>
            <div class="p-0 select col-8 col-md-9 col-lg-10">
              <kendo-dropdownlist class="form-control" v-model="salesType"
                :option-label="'Select Sales Type'"
                :data-source="salesTypeDS"
                :data-text-field="'name'"
                :data-value-field="'name'" @change="getFinalPrice"></kendo-dropdownlist>
              <small v-bind:class=" { 'd-none': verification.type } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Sales Date</label>
            <div class="col-8 col-md-5 p-0">
              <kendo-datepicker v-model="salesDate" class="form-control"></kendo-datepicker>
              <small v-bind:class=" { 'd-none': verification.date } " class="form-feedback error">This field is required</small>
            </div>
            <div class="col-8 offset-4 offset-md-0 col-md-3" style="padding-right: 0px;">
              <kendo-timepicker v-model="salesTime" format="HH:mm" class="form-control"></kendo-timepicker>
            </div>
          </div>
          <hr/>
          <div class="row">
            <div class="col-12 p-0 text-right" style="margin-bottom: 10px;">
            </div>
          </div>
          <template v-for="(cart, index) in carts">
            <div class="form-group row" :key="'prod-' + index">
              <label class="col-4 col-md-3 col-lg-2">Carts - {{ index + 1 }}</label>
              <div class="col-8 col-md-9 col-lg-10">
                <div class="row">
                  <div class="col-12 col-md-5 p-0">
                      <vue-select :placeholder="'Select Product'" :filterable="false" 
                          :options="products" @search="searchProduct" :multiple="false" 
                          :ref="'select-product' + index" v-model="carts[index].product"
                          @change="getFinalPrice">
                        <template slot="no-options">
                          type to search product
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            {{ option.name.toUpperCase() }} - {{ option.code.toUpperCase() }}
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.name.toUpperCase() }} - {{ option.code.toUpperCase() }}
                          </div>
                        </template>
                      </vue-select>
                  </div>
                  <div class="col-12 col-md-2">
                    <input type="number" class="form-control" v-model="cart.qty"
                      placeholder="Quantity" style="height: 40px;" @change="getFinalPrice"/>
                  </div>
                  <div class="col-12 col-md-4 p-0">
                    <numeric-text-box :min="0" :format="'c'" culture="id-ID" :value="cart.discount"
                      class="form-control" :placeholder="'Discount'" @change="discountChange($event, index)"></numeric-text-box>
                  </div>
                  <div class="col-md-1 text-right" style="padding-right: 0px;">
                    <button v-if="index == 0" class="btn btn-primary" @click="addCart" style="height: 35px"><i class="fa fa-plus"></i></button>
                    <button v-if="index > 0" class="btn btn-outline-danger" style="height: 35px" @click="removeCart(index)" ><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <small v-bind:class=" { 'd-none': verification.carts } " class="form-feedback error col-8 col-md-9 col-lg-10 offset-4 offset-md-3 offset-lg-2 p-0">This field is required</small>
          <hr/>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Shipping Cost</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <numeric-text-box :min="0" :format="'c'" culture="id-ID" :value="cost.shipment"
                class="form-control" :placeholder="'Shipping Cost'" @change="shippingChange"></numeric-text-box>
              <small v-bind:class=" { 'd-none': verification.shipping } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Final Price</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <numeric-text-box :format="'c'" v-model="total" culture="id-ID" class="form-control" 
                :placeholder="'Final Price'" :readOnly="true"></numeric-text-box>
            </div>
          </div>
          <hr/>
          <div class="form-group row" v-bind:class="{ 'd-none': salesType !== 'RESELLER' && salesType !== 'DROPSHIP' }">
            <label class="col-4 col-md-3 col-lg-2"><span class="d-none d-md-inline">Selling </span>Partner</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <vue-select :placeholder="'Select Partner (search by name)'" :filterable="false" 
                  :options="partners" @search="searchPartner" :multiple="false" v-model="partner"
                  :ref="'select-partner'"
                  @change="getFinalPrice">
                <template slot="no-options">
                  type to search partner
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.name.toUpperCase() }} / {{ option.email }} / {{ option.phone.toUpperCase() }} / {{ option.city }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.name.toUpperCase() }} / {{ option.email }} / {{ option.phone.toUpperCase() }} / {{ option.city }}
                  </div>
                </template>
              </vue-select>
            </div>
            <small v-bind:class=" { 'd-none': verification.partner } " class="form-feedback error col-8 col-md-9 col-lg-10 offset-4 offset-md-3 offset-lg-2 p-0">This field is required</small>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Customer<span class="d-none d-md-inline"> Type</span></label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <kendo-switch :on-label="'INTERNAL'" :off-label="'EXTERNAL'" :checked="customer.internal" @change="switchChange"></kendo-switch>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Customer Name</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="text" v-model="customer.name" class="form-control" placeholder="Customer Name"/>
              <small v-bind:class=" { 'd-none': verification.customer } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Phone<span class="d-none d-md-inline"> Number</span></label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <!-- <input type="number" v-model="customer.phone" class="form-control" placeholder="Customer Phone Number" v-on:scroll="eventScroll"/> -->
              <kendo-maskedtextbox title="phone number" v-model="customer.phone" mask="0000-0000-00000" class="form-control" placeholder="Customer Phone Number"></kendo-maskedtextbox>
              <small v-bind:class=" { 'd-none': verification.phone } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Email</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="email" v-model="customer.email" class="form-control" placeholder="Customer Email"/>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Address</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <vue-google-autocomplete ref="mapautocomplete" id="map" classname="form-control" placeholder="Customer Address" 
                v-on:placechanged="getAddressData" :country="'id'"
                v-on:change="addressChange" :value="customer.address">
              </vue-google-autocomplete>
              <small v-bind:class=" { 'd-none': verification.address } " class="form-feedback error">This field is required</small>
              <small v-bind:class=" { 'd-none': verification.places } " class="form-feedback error">Address not found. Please search the nearest location for the address!</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Notes</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <textarea v-model="customer.notes" class="form-control" placeholder="Notes on Customer"></textarea>
            </div>
          </div>
          <hr/>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Account Name</label>
            <div class="col-8 col-md-9 col-lg-10 p-0">
              <input type="text" v-model="payment.account" class="form-control" placeholder="Bank Account Name"/>
              <small v-bind:class=" { 'd-none': verification.account } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Payment Date</label>
            <div class="col-8 col-md-5 p-0">
              <kendo-datepicker v-model="payment.date" class="form-control"></kendo-datepicker>
            </div>
            <div class="col-8 offset-4 offset-md-0 col-md-3" style="padding-right: 0px;">
              <kendo-timepicker v-model="payment.time" format="HH:mm" class="form-control"></kendo-timepicker>
            </div>
          </div>
          <hr/>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Channel</label>
            <div class="p-0 select col-8 col-md-9 col-lg-10">
              <kendo-dropdownlist class="form-control" 
                :option-label="'Select Sales Channel'"
                :data-source="channelDS"
                :data-text-field="'name'"
                :data-value-field="'name'"
                :value="channel"
                @change="channelChange"></kendo-dropdownlist>
              <small v-bind:class=" { 'd-none': verification.channel } " class="form-feedback error">This field is required</small>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-md-3 col-lg-2">Logistic</label>
            <div class="p-0 select col-8 col-md-9 col-lg-10">
              <kendo-dropdownlist class="form-control" 
                :option-label="'Select Logistic'"
                :data-source="logisticDS"
                :data-text-field="'name'"
                :data-value-field="'name'"
                :value="logistic"
                @change="logisticChange"></kendo-dropdownlist>
              <small v-bind:class=" { 'd-none': verification.logistic } " class="form-feedback error">This field is required</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-right p-0">
      <button class="btn btn-primary" @click="submit"><i class="fa fa-save"></i>&nbsp;&nbsp;UPDATE SALES</button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { NumericTextBox } from '@progress/kendo-inputs-vue-wrapper'
import DatePicker from 'vuejs-datepicker'
import VueNumeric from 'vue-numeric'
import VueSelect from 'vue-select'
import axios from 'axios'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

var token = JSON.parse(localStorage.getItem('token'))
var accessToken = ''
if (token) {
  accessToken = token.access_token
}

const axiosInstance = axios.create({
  baseURL: process.env.API_SERVER,
  headers: {
    'Authorization': 'Bearer ' + accessToken
  }
})

var channels = []

export default {
  data () {
    return {
      uid: '',
      salesDate: moment().format('DD-MM-YYYY'),
      salesTime: moment().format('HH:mm'),
      salesType: null,
      partner: null,
      customer: {
        internal: false,
        name: null,
        phone: null,
        address: null,
        email: null,
        places: null,
        notes: null,
        city: null
      },
      cost: {
        shipment: null
      },
      total: null,
      payment: {
        type: null,
        account: null,
        date: moment().format('DD-MM-YYYY'),
        time: moment().format('HH:mm')
      },
      carts: [
        {
          product: null,
          code: '',
          qty: null,
          discount: null
        }
      ],
      channel: null,
      logistic: null,
      verification: {
        type: true,
        date: true,
        carts: true,
        shipping: true,
        customer: true,
        phone: true,
        address: true,
        account: true,
        channel: true,
        logistic: true,
        partner: true,
        places: true,
        city: true
      },
      // data sources
      salesTypeDS: {
        transport: {
          read: function (event) {
            axiosInstance.get('api/inventory/outbound/type/')
              .then(
                (response) => {
                  event.success(response.data)
                }
              )
          }
        }
      },
      products: [],
      partners: [],
      logisticDS: {
        transport: {
          read: function (event) {
            axiosInstance.get('api/inventory/logistic/')
              .then(
                (response) => {
                  event.success(response.data)
                }
              )
          }
        }
      },
      channelDS: {
        transport: {
          read: function (event) {
            axiosInstance.get('api/sales/channels/')
              .then(
                (response) => {
                  channels = response.data
                  event.success(response.data)
                }
              )
          }
        }
      }
    }
  },
  components: {
    NumericTextBox,
    DatePicker,
    VueNumeric,
    VueSelect,
    VueGoogleAutocomplete
  },
  created () {
    this.uid = this.$route.params.uid
    this.getSales()
  },
  methods: {
    getSales () {
      var vm = this
      vm.axios.get('api/sales/logs/' + vm.uid + '/')
        .then(
          (response) => {
            console.log(response)
            var data = response.data
            vm.salesDate = moment(data.sales_time).format('DD-MM-YYYY')
            vm.salesTime = moment(data.sales_time).format('HH:mm')
            vm.salesType = data.outbound_type
            vm.carts = data.cart
            vm.cost = data.cost
            vm.total = Number(data.price)
            vm.partner = data.partner_detail
            vm.customer = data.customer
            vm.payment.account = data.account_name
            vm.payment.date = moment(data.payment_time).format('DD-MM-YYYY')
            vm.payment.time = moment(data.payment_time).format('HH:mm')
            vm.channel = data.channel
            vm.logistic = data.logistic

            for (var i = 0; i < vm.carts.length; i++) {
              vm.getProduct(vm.carts[i].product.code)
            }
          }
        )
        .catch(
          (error) => {
            console.log(error)
            vm.$router.push('Four Oh Four')
          }
        )
    },
    searchProduct (search, loading) {
      var vm = this
      loading(true)
      vm.axios.get('api/sales/products/search/' + encodeURIComponent(search) + '/?limit=10&offset=0')
        .then(
          (response) => {
            vm.products = response.data
            loading(false)
          }
        )
    },
    searchPartner (search, loading) {
      var vm = this
      loading(true)
      vm.axios.get('api/user/partner/?name=' + encodeURIComponent(search + ';contains') + '&limit=10&offset=0')
        .then(
          (response) => {
            vm.partners = response.data.results
            loading(false)
          }
        )
    },
    discountChange (event, index) {
      this.carts[index].discount = event.sender.value()
      this.getFinalPrice()
    },
    shippingChange (event) {
      this.cost.shipment = event.sender.value()
      this.getFinalPrice()
    },
    switchChange (event) {
      this.customer.internal = event.sender.value()
    },
    addressChange (event) {
      this.customer.address = event
    },
    getCityData (addressData, placeResultData, id) {
      this.customer.city = {
        address_components: placeResultData.address_components,
        formatted_address: placeResultData.formatted_address
      }
      console.log(this.customer)
    },
    channelChange (event) {
      if (event.sender) {
        this.channel = event.sender.value()
        for (var i = 0; i < channels.length; i++) {
          if (this.channel.toUpperCase() === channels[i].name.toUpperCase()) {
            var channel = channels[i]
            if (channel.is_platform) {
              this.payment.account = channel.name
            }
          }
        }
      }
    },
    logisticChange (event) {
      if (event.sender) {
        this.logistic = event.sender.value()
      }
    },
    addCart () {
      var cart = {
        product: null,
        qty: null,
        discount: 0
      }
      this.carts.push(cart)
    },
    removeCart (index) {
      this.carts.splice(index, 1)
    },
    getProduct (code) {
      var vm = this
      vm.axios('api/sales/products/' + code + '/')
        .then(
          (response) => {
            var product = response.data
            var prices = product.prices
            for (var i = 0; i < vm.carts.length; i++) {
              if (vm.carts[i].product.code === code) {
                vm.carts[i].product.prices = prices
              }
            }
          }
        )
    },
    getFinalPrice () {
      var price = 0
      // product pricing
      console.log(this.carts)
      for (var i = 0; i < this.carts.length; i++) {
        var type = this.salesType
        var sellPrice = 0
        if (this.carts[i].product && type in this.carts[i].product.prices) {
          sellPrice = Number(this.carts[i].product.prices[type])
        }
        var initialPrice = Number(sellPrice) * Number(this.carts[i].qty)
        // discount on product
        var discount = 0
        if (this.carts[i].discount) {
          discount = Number(this.carts[i].discount)
        }
        price += initialPrice - discount
      }
      // shipping cost
      var shipping = 0
      if (this.cost.shipment) {
        shipping = Number(this.cost.shipment)
      }
      price += shipping
      // return price
      this.total = Number(price)
    },
    submit () {
      if (this.verify()) {
        // do submit here
        var sales = new URLSearchParams()
        sales.append('sales_type', this.salesType)
        sales.append('sales_time', this.salesDate + ' ' + this.salesTime)
        sales.append('cart', JSON.stringify(this.carts))
        sales.append('cost', JSON.stringify(this.cost))
        sales.append('price', this.total)
        sales.append('customer', JSON.stringify(this.customer))
        sales.append('account_name', this.payment.account)
        sales.append('payment_time', this.payment.date + ' ' + this.payment.time)
        sales.append('channel', this.channel)
        sales.append('logistic', this.logistic)
        if (this.partner && this.partner.uid) {
          sales.append('partner', this.partner.uid)
        }
        var vm = this
        vm.axios.put('api/sales/logs/' + vm.uid + '/', sales)
          .then(
            (response) => {
              if (response.status === 201) {
                vm.$parent.showNotification('Sales for ' + vm.customer.name + ' successfully updated', 'success')
                vm.$router.push('/sales')
              } else {
                vm.$parent.showNotification('Oops! Unable to submit data at this moment. Please try again later!', 'danger')
              }
            }
          )
      }
    },
    verify () {
      var vm = this
      if (vm.salesType === null || (vm.salesType && vm.salesType.length === 0)) {
        vm.verification.type = false
        return false
      } else {
        vm.verification.type = true
      }
      if ((vm.salesType === 'DROPSHIP' || vm.salesType === 'RESELLER') && vm.partner === null) {
        vm.verification.partner = false
        return false
      } else {
        vm.verification.partner = true
      }
      if (vm.salesDate === null || (vm.salesDate && vm.salesDate.length === 0)) {
        vm.verification.date = false
        return false
      } else {
        vm.verification.date = true
      }
      if (vm.carts && vm.carts.length > 0) {
        for (var cart in vm.carts) {
          if (cart.product === null || cart.qty === null || (cart.qty !== null && cart.qty === 0)) {
            vm.verification.carts = false
            return false
          }
        }
        vm.verification.carts = true
      } else {
        vm.verification.carts = false
        return false
      }
      if (!vm.cost.shipment) {
        vm.cost.shipment = 0
      }
      if (vm.customer.name === null || (vm.customer.name && vm.customer.name.length === 0)) {
        vm.verification.customer = false
        return false
      } else {
        vm.verification.customer = true
      }
      if (vm.customer.phone === null || (vm.customer.phone && vm.customer.phone.length === 0)) {
        vm.verification.phone = false
        return false
      } else {
        vm.verification.phone = true
      }
      if (this.customer.places === null || (this.customer.places !== null && 'address_components' in this.customer.places && this.customer.places.length === 0)) {
        this.verification.places = false
        return false
      } else {
        this.verification.places = true
      }
      if (vm.customer.address === null || (vm.customer.address && vm.customer.address.length === 0)) {
        vm.verification.address = false
        return false
      } else {
        vm.verification.address = true
      }
      if (vm.payment.account === null || (vm.payment.account && vm.payment.account.length === 0)) {
        vm.verification.account = false
        return false
      } else {
        vm.verification.account = true
      }
      if (vm.channel === null || (vm.channel && vm.channel.length === 0)) {
        vm.verification.channel = false
        return false
      } else {
        vm.verification.channel = true
      }
      if (vm.logistic === null || (vm.logistic && vm.logistic.length === 0)) {
        vm.verification.logistic = false
        return false
      } else {
        vm.verification.logistic = true
      }
      return true
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData (addressData, placeResultData, id) {
      this.customer.places = {
        address_components: placeResultData.address_components,
        formatted_address: placeResultData.formatted_address,
        url: placeResultData.url
      }
      console.log(this.customer)
    }
  },
  watch: {
    partner: function (value) {
      console.log(value)
      if (this.value && this.salesType === 'RESELLER') {
        this.customer.name = value.name
        this.customer.address = value.address
        this.customer.places = value.cities
        this.customer.email = value.email
        this.customer.phone = value.phone
      }
    }
  }
}
</script>

<style>
  /* custom css here */
  .form-group > label {
    padding: 7px 15px;
    margin: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/sales/EditSales.vue